import React from 'react';
import {
  StyleSheet,
  View,
  Text,
  ScrollView,
} from './components/base_components';
import { BusyComponent, BusyOverlay } from './components/busy_component';

import Checkbox from './components/checkbox';
import Header from './components/header';
import ProgressSpinner from './components/progress_spinner';
import TextButton from './components/buttons/text_button';

import VolumeStore from './stores/volume_store';

const styles = StyleSheet.create({
  volumeEditScreen: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'transparent',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  scroller: {
    flex: 1,
    alignSelf: 'stretch',
    flexDirection: 'column',
  },
  scrollInner: {
    paddingLeft: '3em',
    paddingRight: '3em',
    paddingTop: '1em',
    paddingBottom: '5em',
    alignSelf: 'stretch',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    overflowY: 'scroll',
  },
  line: {
    alignSelf: 'stretch',
    height: '1px',
    backgroundColor: 'black',
  },
  topView: {
    marginTop: '1em',
    marginBottom: '1em',
    flexDirection: 'column',
  },
  topText: {
    fontSize: '1.1em',
    lineHeight: '2em',
    fontWeight: 'bold',
  },
  propValue: {
    height: '2em',
    borderBottom: '1px solid whitesmoke',
    justifyContent: 'flex-start',
    alignItems: 'center',
    ':hover': {
      backgroundColor: 'lightblue !important',
    },
  },
  propNameText: {
    width: '15em',
    fontSize: '1.1em',
    fontWeight: 'bold',
  },
  propValueText: {
    marginRight: '2em',
    fontSize: '1.1em',
  },
  checkbox: {},
  checkboxText: {
    marginLeft: '0.4em',
    fontSize: '1.1em',
  },
  headerText: {
    marginTop: '0.5em',
    color: '#222',
    fontSize: '1.2em',
    fontWeight: 'bold',
  },
  list: {
    marginTop: '1em',
    marginBottom: '1em',
    flexDirection: 'column',
    border: '1px solid whitesmoke',
  },
  add: {
    marginTop: '1em',
  },
  text: {
    marginTop: '1em',
    color: '#222',
    fontSize: '1.2em',
    fontWeight: 'bold',
  },
  itemLine: {
    padding: '0.5em',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    ':hover': {
      backgroundColor: 'lightblue !important',
    },
  },
  value: {
    width: '20em',
  },
  itemButton: {
    height: '2em',
  },
  button: {
    marginTop: '1em',
    width: '15em',
    height: '2.5em',
  },
  addVolume: {
    marginTop: '1em',
    marginBottom: '1em',
    width: '20em',
    height: '2em',
    paddingLeft: '1em',
    color: 'black',
    fontSize: '1.3em',
    fontWeight: 'bold',
    backgroundColor: '#ccc',
    borderRadius: '0.3em',
  },
  odd: {
    backgroundColor: 'transparent',
  },
  even: {
    backgroundColor: '#ddd',
  },
});

type Props = {
  match: any;
};
type State = {
  volume_id: number;
  volume: any;
};

export default class VolumeEditScreen extends BusyComponent<Props, State> {
  constructor(props, context) {
    super(props, context);
    this.state = {
      volume_id: parseInt(this.props.match.params.volume_id),
      volume: null,
    };
  }

  componentDidMount() {
    VolumeStore.addChangeListener(this._onVolumeChange);
    VolumeStore.fetch();
    this._onVolumeChange();
  }
  componentWillUmount() {
    VolumeStore.removeChangeListener(this._onVolumeChange);
  }
  _onVolumeChange = () => {
    const { volume_id } = this.state;
    const volume = VolumeStore.getVolume(volume_id);
    this.setState({ volume });
  };
  _onCheckboxChange = (prop, value) => {
    if (this.setBusy()) {
      const { volume_id } = this.state;
      const opts = { volume_id, [prop]: value };
      VolumeStore.updateVolume(opts, (err) => {
        this.clearBusy();
        if (err) {
          window.alert('Volume Update Failed: ' + err);
        } else {
          VolumeStore.fetch();
        }
      });
    }
  };
  _onRecalcDownloadsPress = () => {
    if (this.setBusy()) {
      const { volume_id } = this.state;
      VolumeStore.calcVolumeDownloads({ volume_id }, (err) => {
        this.clearBusy();
        if (err) {
          window.alert(
            'Recalc failed. Check device stats, it probably worked.'
          );
        }
      });
    }
  };
  _onRecalcUploadsPress = () => {
    if (this.setBusy()) {
      const { volume_id } = this.state;
      VolumeStore.calcVolumeUploads({ volume_id }, (err) => {
        this.clearBusy();
        if (err) {
          window.alert(
            'Recalc failed. Check device stats, it probably worked.'
          );
        }
      });
    }
  };

  render() {
    const { volume } = this.state;

    let content = null;
    if (!volume) {
      content = <ProgressSpinner />;
    } else {
      const { volume_name, is_disabled } = volume;

      content = (
        <>
          <View style={styles.topView}>
            <PropValue name='Volume' value={volume_name} />
            <PropCheckbox
              name='Disabled'
              prop='is_disabled'
              value={is_disabled}
              onChange={this._onCheckboxChange}
            />
          </View>
          <Line />
          <TextButton
            style={styles.button}
            text='Recalc Downloads'
            onPress={this._onRecalcDownloadsPress}
          />
          <TextButton
            style={styles.button}
            text='Recalc Uploads'
            onPress={this._onRecalcUploadsPress}
          />
        </>
      );
    }
    return (
      <View style={styles.volumeEditScreen}>
        <ScrollView
          style={styles.scroller}
          contentContainerStyle={styles.scrollInner}
        >
          <Header hideOrg={true} />
          {content}
        </ScrollView>
        <BusyOverlay isBusy={this.state.is_busy} />
      </View>
    );
  }
}

function Line() {
  return <View style={styles.line} />;
}
function PropValue(props) {
  return (
    <View style={styles.propValue}>
      <Text style={styles.propNameText}>{props.name + ':'}</Text>
      <Text style={styles.propValueText}>{props.value}</Text>
    </View>
  );
}
function PropCheckbox(props) {
  const { name, prop, value, onChange } = props;
  function _onChange(new_value) {
    onChange(prop, new_value);
  }
  return (
    <View style={styles.propValue}>
      <Text style={styles.propNameText}>{name + ':'}</Text>
      <Checkbox
        style={styles.checkbox}
        textStyle={styles.checkboxText}
        text='Disabled'
        value={value}
        onChange={_onChange}
      />
    </View>
  );
}
